enum VendorSubscriptionType {
  Jobs = 'Jobs',
  Candidates = 'Candidates',
  JobsAndCandidates = 'JobsAndCandidates',
  None = 'None',
}

export default VendorSubscriptionType;
